const timeout = 10000

export { timeout }
